import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const fetchReleasedTracks = createAsyncThunk(
	"tracks/fetchReleasedTracks",
	async ({ startIndex, limit }) => {
		const response = await api.get(
			`/releases/by-range?startIndex=${startIndex}&limit=${limit}`
		);
		return response.data || [];
	}
);

export const fetchReleasedTracksByGenre = createAsyncThunk(
	"tracks/fetchReleasedTracksByGenre",
	async ({ startIndex, limit, genre }) => {
		const encodedGenre = encodeURIComponent(genre);
		const response = await api.get(
			`/releases/by-genre?startIndex=${startIndex}&limit=${limit}&genre=${encodedGenre}`
		);
		return response.data || [];
	}
);

export const fetchSupremeEssentials = createAsyncThunk(
	"supremeEssentials/fetchSupremeEssentials",
	async () => {
		const response = await api.get(`/home/supreme-essentials`);
		return response.data || [];
	}
);

export const fetchForYou = createAsyncThunk("foryou/fetchForYou", async () => {
	const response = await api.get(`/home/for-you`);
	return response.data || [];
});

export const fetchLatestPlayLists = createAsyncThunk("latestPlayLists/fetchLatestPlayLists", async () => {
	const response = await api.get(`/playlist/home/latest/playlists`);
	return response.data || [];
});

export const fetchAllHomeRemixers = createAsyncThunk("Remixers/fetchAllHomeRemixers", async () => {
	const response = await api.get(`/remixers/home/all`);
	return response.data || [];
});

export const fetchFilteredTracks = createAsyncThunk(
	"advancedFiltering/fetchFilteredTracks",
	async ({ pagination, filters }) => {
		const response = await api.post(`/filter`, {
			pagination,
			filter: {
				...filters,
			},
		});
		return response.data || [];
	}
);

export const increaseDownloadCount = createAsyncThunk(
	"tracks/increaseDownloadCount",
	async ({ trackId, editId, remixerId, versionId } = {}) => {
		const response = await api.post(`/download/check-eligibility`, {
			trackId,
			editId,
			remixerId,
			versionId,
			checkOnly: false,
		});
		return response.data || 0;
	}
);

export const checkDownloadEligibility = createAsyncThunk(
	"downloadEligibility/checkDownloadEligibility",
	async ({ trackId, editId, remixerId, versionId, checkOnly } = {}) => {
		const response = await api.post(`/download/check-eligibility`, {
			trackId,
			editId,
			remixerId,
			versionId,
			checkOnly,
		});
		return response.data || false;
	}
);

// reduce download count by 1
export const decreaseDownloadCount = createAsyncThunk(
	"tracks/decreaseDownloadCount",
	async ({ trackId, editId, remixerId, versionId }) => {
		const response = await api.patch(`/download/decrease-download/`, {
			trackId,
			editId,
			remixerId,
			versionId,
		});
		return response.data || 0;
	}
);

export const fetchDownloadVersions = createAsyncThunk(
	"downloadVersions/fetchAll",
	async () => {
		try {
			const response = await api.get(`/download/user-downloads?t=${Date.now()}`);
			return response.data.data || {};
		} catch (error) {
			// 404 means the user has no download records yet — not a real error
			if (error?.response?.status === 404) {
				return {};
			}
			throw error;
		}
	}
);

export const fetchTrackByTrackID = createAsyncThunk(
	"track/fetchTrackByTrackID",
	async (id) => {
		const response = await api.get(`/tracks/get-track/${id}`);
		return response.data || [];
	}
);

export const fetchAllTracks = createAsyncThunk(
	"track/fetchAllTracks",
	async () => {
		const response = await api.get(`/tracks/getalltracks`);
		return response.data || [];
	}
);

export const fetchMixables = createAsyncThunk(
	"track/fetchMixables",
	async ({ upperLimit, lowerLimit, genre, key }) => {
		const response = await api.get(
			`/tracks/getMixables?upperLimit=${upperLimit}&lowerLimit=${lowerLimit}&genre=${genre}&key=${key}`
		);
		return response.data || [];
	}
);

export const fetchUserDownloadTracks = createAsyncThunk(
	"userDownloads/fetchUserDownloadTracks",
	async ({ userId, page, size, sortField, sortOrder }) => {
		const response = await api.post(`/download/user-downloads`, {
			userId,
			page,
			size,
			sortField,
			sortOrder,
		});
		return response.data || [];
	}
);

export const fetchLatestTwelveTracks = createAsyncThunk(
	"userDownloads/fetchLatestTwelveTracks",
	async () => {
		const response = await api.get(`/home/new-releases`);
		return response.data || [];
	}
);

export const fetchCharts = createAsyncThunk(
	"charts/fetchCharts",
	async ({genre, period}) => {
		const response = await api.get(`/charts?genre=${genre}&period=${period}`);
		return response.data;
	}
);